import { render, staticRenderFns } from "./kiosks.vue?vue&type=template&id=167675e0&"
import script from "./kiosks.vue?vue&type=script&lang=js&"
export * from "./kiosks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports